import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { LIST_TRANSACTIONS } from "redux/model/transactions/transactions/constants";
import { apiListTransactions } from "api/transaction/transactionApi";
import {
  listTransactionsFailed,
  listTransactionsSuccess
} from "redux/model/transactions/transactions/transactionsActions";
import { generateErrorMessage, throwFrontError } from "@tmatt-tech/allaroundmassage_frontend_common";


function* transactionsSaga() {
  yield all([
    fork(watchListTransactions),
  ]);
}

// List Transactions
export function* watchListTransactions() {
  yield takeEvery(LIST_TRANSACTIONS, sagaListTransactions);
}

export function* sagaListTransactions({ payload }) {
  try {
    const response = yield call(apiListTransactions, payload);

    yield put(listTransactionsSuccess({ transactions: response.data }));

  } catch (e) {
    yield put(listTransactionsFailed(generateErrorMessage(e)));
    throwFrontError(e);
  }
}


export default transactionsSaga;
